module.exports = __webpack_public_path__ + "img/events-4.743581d6.png";